/** First letter of the first two words, max 2 chars. "Beta Test Student" → "BT". */
export function initialsFromName(name?: string | null, fallback = "?"): string {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return fallback;
  if (parts.length === 1) {
    const word = parts[0] || "";
    return (word.slice(0, 2) || fallback).toUpperCase();
  }
  return `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}`.toUpperCase() || fallback;
}

export function getDisplayName(user: {
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
}): string {
  return (
    user.name ||
    [user.firstName, user.lastName].filter(Boolean).join(" ").trim() ||
    user.username ||
    ""
  );
}

export function getAvatarFallback(user: {
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
}): string {
  return initialsFromName(getDisplayName(user));
}
